import React, { useEffect, useState, useCallback } from "react";
import LinkContainer from "./LinkContainer/index";
import Bus from "@/utils/bus";

export default function LinkContainerPage() {
  const [url, setUrl] = useState<string>("");
  const [appInfo, setAppInfo] = useState<any>(null);
  const changUrl = useCallback((data) => {
    let { url, appInfo } = data;
    setUrl(url);
    setAppInfo(appInfo);
  }, []);
  useEffect(() => {
    Bus.on("linkContainer:linkUrl", changUrl);
    return () => {
      Bus.off("linkContainer:linkUrl", changUrl);
    };
  }, []);
  return <LinkContainer url={url.toString()} appInfo={appInfo} />;
}
